import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { MessageSquare, Save, RefreshCw } from "lucide-react";

const CATEGORY_LABELS = {
  paie: "Paie", documents: "Documents", planning: "Planning", conges: "Congés & absences", support: "Support",
  facturation: "Facturation", education: "Éducation", reservation: "Réservations & clients", rh: "RH — contrats",
  commercial: "Commercial — CRM", systeme: "Système", recrutement: "Recrutement — PAG JOB",
};
const PRIORITY = { urgent: "bg-[#E60000] text-white", high: "bg-[#F59E0B] text-white", medium: "bg-[#0EA5E9] text-white", low: "bg-[#868E96] text-white" };

export const TwilioEventsTab = () => {
  const [catalog, setCatalog] = useState([]);
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/twilio/events");
      setCatalog(data.catalog || []);
      setValues(data.events || {});
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/twilio/events", { events: values });
      setValues(data.events || {});
      toast.success("Interrupteurs SMS enregistrés pour toute la plateforme");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const groups = catalog.reduce((acc, e) => { (acc[e.category] = acc[e.category] || []).push(e); return acc; }, {});
  const onCount = catalog.filter((e) => (values[e.key] || {}).sms !== false).length;

  return (
    <div className="bg-white border border-[#DEE2E6] p-5" data-testid="tw-events-tab">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-3">
        <div>
          <div className="font-display font-bold text-lg flex items-center gap-2"><MessageSquare className="h-5 w-5 text-[#002FA7]" />Événements envoyés par SMS</div>
          <div className="text-[11px] text-[#495057] max-w-2xl">
            Interrupteurs <b>plateforme</b> : un événement coupé ici n'envoie plus aucun SMS, pour toutes les entreprises.
            Chaque gérant peut ensuite restreindre davantage dans ses réglages, et chaque salarié pour lui-même.
            Les autres canaux (email, cloche, push) ne sont pas concernés.
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={load} data-testid="tw-events-reload"><RefreshCw className="h-4 w-4 mr-1" />Recharger</Button>
          <Button onClick={save} disabled={saving} className="bg-[#002FA7] text-white" data-testid="tw-events-save"><Save className="h-4 w-4 mr-1" />{saving ? "Enregistrement…" : "Enregistrer"}</Button>
        </div>
      </div>
      <div className="text-[10px] uppercase tracking-wider font-bold text-[#868E96] mb-3" data-testid="tw-events-count">{onCount} / {catalog.length} événements actifs en SMS</div>
      <div className="space-y-3">
        {Object.entries(groups).map(([cat, list]) => (
          <div key={cat} className="border border-[#DEE2E6]" data-testid={`tw-events-group-${cat}`}>
            <div className="px-3 py-2 bg-[#F8F9FA] text-[10px] uppercase tracking-[0.2em] font-bold border-b border-[#DEE2E6]">{CATEGORY_LABELS[cat] || cat}</div>
            <div className="divide-y divide-[#DEE2E6]">
              {list.map((e) => {
                const on = (values[e.key] || {}).sms !== false;
                return (
                  <div key={e.key} className="px-3 py-2.5 flex flex-wrap items-center gap-2">
                    <div className="flex-1 min-w-[200px]">
                      <div className="text-sm font-semibold">{e.label}</div>
                      <div className="text-[10px] text-[#868E96] flex items-center gap-2">Destinataire : {e.audience}
                        <span className={`text-[9px] uppercase font-bold px-1.5 py-0.5 ${PRIORITY[e.priority] || PRIORITY.medium}`}>{e.priority}</span>
                      </div>
                    </div>
                    <button type="button" onClick={() => setValues((v) => ({ ...v, [e.key]: { sms: !on } }))} data-testid={`tw-event-toggle-${e.key}`} data-on={on ? "1" : "0"}
                            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-bold px-2.5 py-1.5 border transition ${on ? "bg-[#059669] text-white border-[#059669]" : "bg-white text-[#868E96] border-[#DEE2E6]"}`}>
                      <MessageSquare className="h-3 w-3" />{on ? "SMS actif" : "SMS coupé"}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
